module.exports = __webpack_public_path__ + "bd_rvcnn.jpg?cb65ee65c9dc5bb3b64d6f46c0412319";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/rvcnn/bd_rvcnn.jpg
// module id = 92
// module chunks = 0